<template>
  <div @mousemove="onMouseMove" @mouseup="onMouseUp" class="split-panel">
    <div :style="{ [type]:`calc(${precent}% - ${gapSize / 2}px)` }" class="absolute" :class="[fClass]">
      <slot name="paneFBtn" />
      <slot name="paneF" />
    </div>
    <div class="resize" :style="[{ [resizeType]:`calc(${precent}% - ${gapSize / 2}px)`, [type]: `${gapSize}px` }]" :class="[`${splitInfo.direction || 'vertical'}-resizer`, isDisabled ? 'disabled-resize' : '']" @mousedown="onMouseDown"/>
    <div :style="{ [type]:`calc(${100-precent}% - ${gapSize / 2}px)` }" class="absolute" :class="[sClass]">
      <slot name="paneSBtn" />
      <slot name="paneS" />
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
export default {
  // 组件名称
  name: 'splitPanel',
  // 组件参数 接收来自父组件的数据
  props: {
    // 必须的参数
    splitInfo: {
      type: Object,
      default: () => {
        return {
          // direction : 'level 上下结构 | vertical   左右结构'
          defaultPrecent: 50,
          direction: 'level',
          minPercent: 0,
          maxPercent: 0
        }
      }
    },
    // 是否禁止拖拽
    isDisabled: {
      type: Boolean,
      default: false
    },
    // 间隙背景
    splitBg: {
      type: Object,
      default: ()=> ({})
    },
    // 间隙大小
    gapSize: {
      type: Number,
      default: 10
    }
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
    return {
      precent: 50,
      type: 'width',
      isActive: false,
      fClass: `${this.splitInfo.direction}-f`,
      sClass: `${this.splitInfo.direction}-s`,
      resizeType: 'top'
    }
  },
  // 计算属性
  computed: {
    isLev () {
      return this.splitInfo.direction === 'level'
    }
  },
  created () {
    this.init()
  },
  mounted () {
    document.addEventListener('mouseup', this.onCancleActive)
  },
  beforeUnmount () {
    document.removeEventListener('mouseup', this.onCancleActive)
  },
  // 侦听器
  watch: {
    splitInfo: {
      handler () {
        this.init()
      }
    }
  },
  // 组件方法
  methods: {
    init () {
      const { defaultPrecent = 50, direction } = cloneDeep(this.splitInfo)
      this.precent = defaultPrecent
      this.type = this.isLev ? 'height' : 'width'
      this.resizeType = this.isLev ? 'top' : 'left'
      this.fClass = `${direction}-f`
      this.sClass = `${direction}-s`
    },
    onMouseDown() {
      if (this.isDisabled) return
      this.isActive = true
    },
    onCancleActive () {
      this.isActive = false
    },
    onMouseMove (e) {
      if (this.isActive) {
        const curtarget = e.currentTarget
        let target = e.currentTarget
        // 容器距离浏览器顶部/左边的距离
        let offset = 0
        while (target) {
          offset += this.isLev ? target.offsetTop : target.offsetLeft
          target = target.offsetParent
        }
        // 拖拽先距离容器顶/左的距离
        const currentPage = this.isLev ? e.pageY : e.pageX
        // 容器的宽度或者高度
        const targetWidth = this.isLev ? curtarget.offsetHeight : curtarget.offsetWidth
        // 计算出百分比
        const percents = Math.floor(((currentPage - offset) / targetWidth) * 10000) / 100

        if (this.splitInfo.minPercent && percents < this.splitInfo.minPercent) return
        if (this.splitInfo.maxPercent && percents > this.splitInfo.maxPercent) return
        if (percents >= 100) return
        this.precent = percents
        this.$emit('change', percents)
      }
    },
    onMouseUp () {
      this.onCancleActive()
    },
    changePos () {
      this.$emit('change-pos')
    }
  }
}
</script>

<style scoped lang="scss">
.split-panel {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .resize {
    position: absolute;
    background-color: rgb(244, 245, 245);
    z-index: 2;
  }
  .vertical-resizer {
    height: 100%;
    width: 10px;
    cursor: col-resize;
  }

  .disabled-resize {
    cursor: default !important;
  }

  .level-resizer {
    width: 100%;
    height: 10px;
    cursor: row-resize;
  }
  .absolute {
    position: absolute;
    transition: .3s;
  }

  .vertical-f {
    left: 0;
    height: 100%;
  }

  .vertical-s {
    right: 0;
    height: 100%;
  }

  .level-f {
    top: 0;
    width: 100%;
  }

  .level-s {
    bottom: 0;
    width: 100%;
  }
}
</style>
